import {md5} from "@pg-mono/string-utils";

/**
 * Hashes user email for Amplitude User ID — shared between RP, KM, and other products.
 */
export const hashEmailForAmplitudeUserId = (email: string): string => md5(email.trim().toLowerCase());
import {md5} from "@pg-mono/string-utils";

/**
 * Hashes user email for Amplitude User ID — shared between RP, KM, and other products.
 */
export const hashEmailForAmplitudeUserId = (email: string): string => md5(email.trim().toLowerCase());
